import store from '@/store'
import { statsOffersCurrentWeek, getUsers, offersPublished, offersWaiting } from '@/backend/dashboard';

const STATS_OFFERS_CURRENT_WEEK = 'STATS_OFFERS_CURRENT_WEEK';
const LATEST_CONFIRMED_USERS = 'LATEST_CONFIRMED_USERS';
const LATEST_PENDING_USERS = 'LATEST_PENDING_USERS';
const LATEST_ACTIVE_USERS = 'LATEST_ACTIVE_USERS';
const SET_OFFERS_PUBLISHED = 'SET_OFFERS_PUBLISHED';
const SET_OFFERS_WAITING = 'SET_OFFERS_WAITING';
const SET_ACTIVE_CANDIDATE = 'SET_ACTIVE_CANDIDATE';

const state = {
  statsOffersCurrentWeek: {},
  latestConfirmedUsers: { users: [], total: 0, latest_total: 0 },
  latestPendingUsers: { users: [], total: 0, latest_total: 0 },
  latestActiveUsers: { users: [], total: 0, latest_total: 0 },
  listOfferPublished: {
    data: [],
    count: 0
  },
  listOfferWaiting: {
    data: [],
    count: 0
  },
  activeCandidate: {}
};

export const mutations = {
  [STATS_OFFERS_CURRENT_WEEK](state, statsOffersCurrentWeek) {
    state.statsOffersCurrentWeek = statsOffersCurrentWeek
  },
  [LATEST_CONFIRMED_USERS](state, latestConfirmedUsers) {
    state.latestConfirmedUsers = latestConfirmedUsers
  },
  [LATEST_PENDING_USERS](state, latestPendingUsers) {
    state.latestPendingUsers = latestPendingUsers
  },
  [LATEST_ACTIVE_USERS](state, latestActiveUsers) {
    state.latestActiveUsers = latestActiveUsers
  },
  [SET_OFFERS_PUBLISHED] (state, response) {
    state.listOfferPublished.data = response.offers_published;
    state.listOfferPublished.count = response.published_count;
  },
  [SET_OFFERS_WAITING] (state, response) {
    state.listOfferWaiting.data = response.offers_waiting;
    state.listOfferWaiting.count = response.waiting_count;
  },
  [SET_ACTIVE_CANDIDATE] (state, user) {
    state.activeCandidate = user;
  },
};

export const actions = {
  getStatsOffersCurrentWeek({ commit }, entityId) {
    var params = { entity_id_in: entityId }
    return statsOffersCurrentWeek(params)
      .then((response) => {
        let graph = response.data;
        graph['chart'] = {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          height: 330
        };
        commit(STATS_OFFERS_CURRENT_WEEK, graph)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },
  getLatestConfirmedUsers({ commit }, entityId) {
    var params = {
      entity_id: entityId,
      state: 'confirmed',
      limit: 3
    }
    return getUsers(params)
      .then((response) => {
        var data = response.data
        commit(LATEST_CONFIRMED_USERS, { users: data.latest_users, total: data.total, latest_total: data.latest_total });
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },
  getLatestPendingUsers({ commit }, entityId) {
    var params = {
      entity_id: entityId,
      state: 'pending',
      limit: 3
    }
    return getUsers(params)
      .then((response) => {
        var data = response.data
        commit(LATEST_PENDING_USERS, { users: data.latest_users, total: data.total, latest_total: data.latest_total });
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },
  getLatestActiveUsers({ commit }, entityId) {
    var params = {
      entity_id: entityId,
      state: 'active',
      limit: 3
    }
    return getUsers(params)
      .then((response) => {
        var data = response.data
        commit(LATEST_ACTIVE_USERS, { users: data.latest_users, total: data.total, latest_total: data.latest_total });
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },
  offersPublished({ commit }, params) {
    return offersPublished(params)
      .then(response => {
        commit(SET_OFFERS_PUBLISHED, response.data)
      })
  },
  offersWaiting({ commit }, params) {
    return offersWaiting(params)
      .then(response => {
        commit(SET_OFFERS_WAITING, response.data)
      })
  },
  initDataCandidateBlock({ commit }, entityId) {
    store.dispatch('dashboard/getLatestConfirmedUsers', entityId)
    store.dispatch('dashboard/getLatestPendingUsers', entityId);
    store.dispatch('dashboard/getLatestActiveUsers', entityId);
  }
};

export const getters = {
  statsOffersCurrentWeek: state => state.statsOffersCurrentWeek,
  latestConfirmedUsers: state => state.latestConfirmedUsers,
  latestPendingUsers: state => state.latestPendingUsers,
  latestActiveUsers: state => state.latestActiveUsers,
  listOfferPublished: state => state.listOfferPublished,
  listOfferWaiting: state => state.listOfferWaiting,
  activeCandidate: state => state.activeCandidate
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}




// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js